import { render } from "./Landing.vue?vue&type=template&id=52bb1935&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=ts"
export * from "./Landing.vue?vue&type=script&lang=ts"

import "./Landing.vue?vue&type=style&index=0&id=52bb1935&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-52bb1935"

export default script